import axios from 'axios';
import apiErrorHandler from './apiErrorHandler';

let store;

export const injectStore = (_store) => {
  store = _store;
};

// const SERVER_URL = "https://api.blackhyve.com/api/"
//let SERVER_URL = 'https://api-staging.blackhyve.com/api/';
//const SERVER_URL = "https://c81851218cac.ngrok.io/api/";
const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}/api/`;

let cancelToken = axios.CancelToken;
let source = cancelToken.source();
let additionalHeaders = {};

export const axiosRequestHandler = async (
  url,
  method,
  body,
  type = null,
  isFileUpload = false,
  isXTenant = true
) => {
  try {
    if (type === 'CANCEL_API_REQUEST') {
      source.cancel('Operation canceled by the user.');
      let CancelToken = axios.CancelToken;
      source = CancelToken.source();
    }
    let headers = {
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
      ...additionalHeaders,
    };

    if (isXTenant) {
      const workspaceId = store.getState().auth.workspaceId;
      headers['Content-Type'] = isFileUpload ? 'multipart/form-data;' : 'application/json';
      if (workspaceId) {
        headers['X-Tenant'] = workspaceId;
      }
    }

    const authToken = store.getState().auth.authToken;
    if (authToken && authToken !== 'undefined') {
      headers['Authorization'] = `Bearer ${authToken}`;
    }

    const socketId = store.getState().auth.socketId;
    if (socketId) {
      headers['X-Socket-ID'] = socketId;
    }

    const result = await axios({
      url: `${SERVER_URL}${url}`,
      defaults: {
        timeout: 20000,
      },
      data: body,
      headers: headers,
      method: method,
      cancelToken: source.token,
    });

    return { error: null, response: result.data };
  } catch (error) {
    const apiError = apiErrorHandler(error);
    return apiError;
  }
};
